import { instance } from "./base.api";

const endpoint = "/pays";

export const payments = {
  getAll: () => {
    return instance.get(endpoint);
  },
  getById: (id: number) => {
    return instance.get(`${endpoint}/${id}`);
  },
  create: (payData: any) => {
    return instance.post(endpoint, payData);
  },
  update: (id: number, payData: any) => {
    return instance.put(`${endpoint}/${id}`, payData);
  },
  delete: (id: number) => {
    return instance.delete(`${endpoint}/${id}`);
  },
};
